const P_ICON_ALIASES = {
  delete: "octicon:trash-24",
  edit: "simple-line-icons:pencil",
  send: "mingcute:send-plane-fill",
  settings: "heroicons:cog-8-tooth-20-solid",
  empty: "ph:empty",
  "chevron-left": "material-symbols:chevron-left-rounded",
  "chevron-right": "material-symbols:chevron-right-rounded",
  "chevron-up": "ph:caret-up",
  "chevron-down": "ph:caret-down",
  "ok-circle": "material-symbols:check-circle",
  "cancel-circle": "material-symbols:cancel",
  ok: "material-symbols:check",
  cancel: "material-symbols:close",
  "ok-bold": "fa:check",
  "cancel-bold": "fa:close",
  archive: "solar:archive-outline",
  lock: "material-symbols:lock",
  "drag-horizontal": "ci:drag-horizontal",
  email: "tabler:mail-filled",
  location: "gridicons:location",
  calendar: "mdi:calendar-today",
  save: "material-symbols:save-rounded",
  copy: "ph:copy",
  plus: "ic:outline-plus",
  add: "ic:outline-plus",
  more: "lineicons:more-alt",
  filters: "mage:filter",
  "bar-chart": "material-symbols:bar-chart-4-bars-rounded",
  list: "material-symbols:format-list-bulleted",
  formula: "fluent:math-formula-20-filled",
  refresh: "ri:loop-left-line",
  download: "tdesign:download",
  upload: "tdesign:upload",
  info: "streamline:information-circle",
  search: "streamline:magnifying-glass-solid"
};
export {
  P_ICON_ALIASES
};
